import i18n from 'i18next'
import { initReactI18next } from 'react-i18next'
import en from '../public/locales/en/player.json'
import zh from '../public/locales/zh/player.json'

// Read ?lang= directly from the URL. Runs outside the React tree, before
// RouterProvider mounts. Do NOT add i18next-browser-languagedetector — its
// priority stack conflicts with the URL-param-first design (D-04).
const raw = new URLSearchParams(window.location.search).get('lang')
const lng = raw === 'zh' ? 'zh' : 'en'

void i18n.use(initReactI18next).init({
  lng,
  fallbackLng: 'en',
  ns: ['player'],
  defaultNS: 'player',
  resources: {
    en: { player: en },
    zh: { player: zh },
  },
  interpolation: { escapeValue: false },
})

export default i18n
